import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GiftIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Gift",
    children: /*#__PURE__*/_jsx("path", {
      d: "m29.44 10.17-6.99-.63c.3-.16.57-.37.81-.62a3.9 3.9 0 0 0 1.06-3.97 2.953 2.953 0 0 0-3.73-1.88c-.15.05-.3.11-.44.19-1.52.58-3.1 2.93-3.61 4.57-.2-.03-.41-.03-.62 0a4.81 4.81 0 0 0-3.05-4.2c-1.89-.73-4.19-.07-4.8 1.66-.42 1.4 0 2.92 1.06 3.92.11.12.24.23.37.33l-6.95.65c-.31.04-.54.3-.54.61v3.4c0 .31.23.57.54.61l1.33.13h.23a.4.4 0 0 0 0 .16v10.89c0 .62.45 1.16 1.06 1.26l2.48.41V10.81c1.31-.31 2.66-.46 4.01-.47.89.16 1.81.19 2.71.07.05 0 0 .11.15.26s.35.3.35.3l-3.4.43-.12 16.89 4.63.78a.9.9 0 0 0 .4 0l4.38-.67V11.24l-3.41-.33s.55-.29.57-.46c.62.03 1.25 0 1.87-.09.18 0 4.54.63 4.54.63l-.16 16.89 2.65-.41c.62-.1 1.07-.64 1.06-1.26V14.99l1.56-.13a.61.61 0 0 0 .56-.61v-3.47c0-.32-.25-.58-.56-.61m-15.9-.63a5.17 5.17 0 0 1-2.96-1.14c-.76-.62-.87-1.73-.25-2.48.01-.01.02-.02.03-.04.86-.54 1.97-.5 2.79.1.78.61 1.36 1.43 1.67 2.37.12.81-.36 1.12-1.28 1.19m5.44 0c-.97 0-1.51-.3-1.39-1.19.27-.96.84-1.82 1.62-2.45a2.48 2.48 0 0 1 2.87 0c.67.78.58 1.95-.2 2.62-.01.01-.03.02-.04.03-.81.65-1.81 1-2.85.99Z"
    })
  }));
};